import React from 'react';
import { Button, Space } from 'antd';
import { useNavigate } from 'react-router-dom';

export const BannersActions = () => {
    const navigate = useNavigate();

    const createBanner = () => {
        navigate(`create`);
    };

    return (
        <Space>
            <Button disabled={false} type={'primary'} onClick={createBanner}>
                Добавить баннер
            </Button>
        </Space>
    );
};
